const oldVersionApi = JSON.parse(process.env.REACT_APP_OLD_VERSION_API || false) || false;

let inputs = {
  name: {
    id: 'name',
    name: 'name',
    input: 'textField',
    label: 'credentialList.form.name.label',
    placeholder: 'credentialList.form.name.placeholder',
    rules: {
      required: { value: true },
    },
  },
  description: {
    id: 'description',
    name: 'description',
    input: 'textField',
    label: 'credentialList.form.description.label',
    placeholder: 'credentialList.form.description.placeholder',
  },
  company: {
    id: 'company',
    name: 'company',
    input: 'select',
    label: 'credentialList.form.company.label',
    helperText: 'credentialList.form.company.helperText',
    rules: {
      required: { value: true },
    },
  },
  type: {
    id: 'typeId',
    name: 'type',
    input: 'select',
    label: 'credentialList.form.type.label',
    rules: {
      required: { value: true },
    },
  },
  tags: {
    id: 'tags',
    name: 'tags',
    type: 'array',
    input: 'textField',
    label: 'credentialList.form.tags.label',
    placeholder: 'credentialList.form.tags.placeholder',
    helperText: 'credentialList.form.tags.helperText',
  },
  user: {
    id: 'user',
    name: 'user',
    input: 'textField',
    label: 'credentialList.form.user.label',
    rules: {
      required: { value: true },
    }
  },
  password: {
    id: 'password',
    name: 'password',
    input: 'textField',
    type: 'password',
    label: 'credentialList.form.password.label',
    rules: {
      required: { value: true },
    }
  },
  enabled: {
    id: 'enabled',
    name: 'enabled',
    type: 'password',
    input: 'textField',
    label: 'credentialList.form.enabled.label',
  },
  privateKey: {
    id: 'privateKey',
    name: 'privateKey',
    input: 'textArea',
    label: 'credentialList.form.privateKey.label',
    minRows: 2,
  },
  token: {
    id: 'token',
    name: 'token',
    input: 'textField',
    type: 'password',
    label: 'credentialList.form.token.label',
    minRows: 2,
  },
  sudo: {
    id: 'sudo',
    name: 'sudo',
    input: 'textField',
    type: 'password',
    label: 'credentialList.form.sudo.label',
  },
  fromEdit: {
    id: 'fromEdit',
    name: 'fromEdit',
  },
}

if (oldVersionApi) {
  //TODO: DELETE THIS PLEASE >:l
  inputs = {
    name: {
      id: 'name',
      name: 'name',
      input: 'textField',
      label: 'credentialList.form.name.label',
      placeholder: 'credentialList.form.name.placeholder',
      rules: {
        required: { value: true },
      },
    },
    description: {
      id: 'description',
      name: 'description',
      input: 'textField',
      label: 'credentialList.form.description.label',
      placeholder: 'credentialList.form.description.placeholder',
    },
    project: {
      id: 'project_id',
      name: 'project',
      input: 'select',
      label: 'credentialList.form.project.label',
      helperText: 'credentialList.form.project.helperText',
    },
    credentials: {
      id: 'txtCred',
      name: 'credentials',
      label: 'credentialList.form.variables.label',
      helperText: 'credentialList.form.variables.helperText',
    },
    fromEdit: {
      id: 'fromEdit',
      name: 'fromEdit',
    },
    baseUrl: {
      id: 'selectProyectoURL',
      name: 'selectProyectoURL',
    }
  }
}

export default inputs;
